import styled from '@emotion/styled';
import { Colors } from 'goalsetter-webapp-components';
import { CardCvcElement } from '@stripe/react-stripe-js';

export const StyledCardCvcElement = styled(CardCvcElement)<{
  hasError?: boolean;
}>`
  border: ${(props) =>
    props.hasError ? `2px solid ${Colors.RED}` : `1px solid ${Colors.GRAY}`};
  border-radius: 12px;
  margin-bottom: ${(props) => (props.hasError ? '10px' : '0')};
  height: 48px !important;
  font-size: 16px !important;
  padding-left: 12px;
`;
